/**<params config data>说明
 * position 控制文本框宽度和文本是否居中 left 跟 right 是一样的，top 跟 bottom 是一样的
 * titleFontSize 标题字号
 * titleColor 标题颜色
 * synopsisFontSize 副标题字号
 * synopsisColor 副标题颜色
 * desFontSize 简介字号
 * desColor 简介颜色
 * itemsColor 额外内容颜色
 * itemsbomColor 额外内容简介颜色
 */
import Image from '@/components/UI/Image';
import EFArrowUp from '@/components/UI/svg/Icons/EFArrowUp';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const item = {
    title: '576Wh Capacity',
    synopsis: 'Double up or go lightweight.',
    desc: 'RIVER Max has two 288Wh batteries. Detach the bottom one when weight takes priority or leave it on to power twice as much.',
    noUseHtmlAttr: true,
};
const configs = {
    position: 'left',
    opacity: 1,
    titleFontSize: 26,
    titleColor: '#03060b',
    synopsisFontSize: 64,
    synopsisLineHeight: 1.13,
    synopsisColor: '#03060b',
    descFontSize: 22,
    descColor: '#666',
    itemsColor: '#03060b',
    itemsDescColor: '#666',
    itemsPhraseColor: '#666',
    zIndex: 1,
    phraseFontSize: 17,
    phraseColor: '#919191',
};
export default function TextBanner({ config, data = item }: any) {
    const { Link, useRouter } = useGlobal();
    const configTypes = {
        ...configs,
        ...config,
    };
    const { locale } = useRouter();

    return (
        <div
            className={`${css.TextBanner} ${configTypes.position === 'left' || configTypes.position === 'right' ? 'page-text' : ''}`}
            style={{
                textAlign: configTypes.position === 'left' || configTypes.position === 'right' ? 'left' : 'center',
                zIndex: configTypes.zIndex,
            }}
        >
            <div key={data.title} className="content">
                {data.icon && <Image src={data.icon} width={configTypes.iconWidth} height={configTypes.iconHeight} alt={data.title} />}
                {data.title !== '' && (
                    <h2
                        className="title font-family-semibold"
                        style={{
                            fontSize: `${configTypes.titleFontSize}px`,
                            color: configTypes.titleColor,
                        }}
                    >
                        {data.title}
                    </h2>
                )}
                {data.synopsis !== '' && (
                    <div
                        className={`${configTypes.gradient ? 'gradient-text' : ''} synopsis font-family-extrabold`}
                        style={{
                            fontSize: `${configTypes.synopsisFontSize}px`,
                            lineHeight: configTypes.synopsisLineHeight || 1.13,
                            color: configTypes.synopsisColor,
                            backgroundImage: configTypes.gradientColor,
                        }}
                        dangerouslySetInnerHTML={{ __html: data.synopsis }}
                    ></div>
                )}
                {data.desc !== '' && data.noUseHtmlAttr && (
                    <div
                        className="desc font-family-bold"
                        style={{
                            fontSize: `${configTypes.descFontSize}px`,
                            color: configTypes.descColor,
                            opacity: configTypes.opacity,
                        }}
                        dangerouslySetInnerHTML={{ __html: data.desc }}
                    ></div>
                )}
                {data.desc !== '' && !data.noUseHtmlAttr && (
                    <div
                        className="desc font-family-bold"
                        style={{
                            fontSize: `${configTypes.descFontSize}px`,
                            color: configTypes.descColor,
                            opacity: configTypes.opacity,
                        }}
                    >
                        {data.desc}
                    </div>
                )}
                {data.newWindLink && ['us', 'ca', 'au', 'uk', 'za'].includes(locale) && (
                    <Link href={data.newWindLink} className="new-wind__link" newWin>
                        <div className="link" style={{ fontSize: `${configTypes.descFontSize}px` }}>
                            <span>{data.linkDesc}</span>
                            <EFArrowUp style={data.svgStyle} />
                        </div>
                    </Link>
                )}
                {data.phrase && data.phrase !== '' && (
                    <div
                        className="phrase"
                        style={{
                            fontSize: `${configTypes.phraseFontSize}px`,
                            color: configTypes.phraseColor,
                        }}
                        dangerouslySetInnerHTML={{ __html: data.phrase }}
                    ></div>
                )}
                <div className="items" style={{ marginTop: data.arr ? '60px' : '0px' }}>
                    <ul>
                        {data.arr &&
                            data.arr.map((list: any) => (
                                <li key={list.num}>
                                    <span className="num font-family-extrabold" style={{ color: configTypes.itemsColor }}>
                                        {list.num}
                                        <span className="unit font-family-bold">{list.eum}</span>
                                    </span>
                                    <span className="desc" style={{ color: configTypes.itemsDescColor }}>
                                        {list.desc}{' '}
                                    </span>
                                    {list.phrase && (
                                        <span
                                            className="phrase"
                                            style={{ color: configTypes.itemsPhraseColor }}
                                            dangerouslySetInnerHTML={{ __html: `${list.phrase} ` }}
                                        ></span>
                                    )}
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
